import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': '人渣游戏深度解析 - 首页',
        'description': '全面剖析人渣游戏的玩法机制、剧情设计、道德争议与玩家评价。',
        'url': 'https://scum-game-analysis.com/',
        'inLanguage': 'zh-CN',
        'isPartOf': {
          '@type': 'WebSite',
          'name': '人渣游戏深度解析',
          'url': 'https://scum-game-analysis.com/',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            '@type': 'ListItem',
            'position': 1,
            'name': '首页',
            'item': 'https://scum-game-analysis.com/',
          }],
        },
      }) }} />
    </>
  );
}